module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_CalloutPhoot_HeavySweating.a48c8155.jpg";